import { useHasAccess } from '@components/HasAccess'
import { Permission } from '@utils/permissions'
import { Col, Layout, Row } from 'antd'
import { Link, Outlet } from 'react-router-dom'
import { LayoutFooter } from '../components/LayoutFooter'
import MainHeader from '../components/MainHeader'

const { Content } = Layout

export const OverviewLayout: React.FC = () => {
  const { hasAccess } = useHasAccess()

  const subItems = [
    {
      key: 'home',
      label: <Link to={'home'}>Home</Link>,
      hasAccess: hasAccess(Permission.listUser),
    },

    {
      key: 'traffic',
      label: <Link to={'traffic'}>Traffic</Link>,
      hasAccess: hasAccess([Permission.listUser]),
    },
    {
      key: 'community',
      label: <Link to={'community'}>Community</Link>,
      hasAccess: hasAccess(Permission.listUser),
    },
    {
      key: 'conversion',
      label: <Link to={'conversion'}>Conversion</Link>,
      hasAccess: hasAccess([Permission.listUser]),
    },
    {
      key: 'revenue',
      label: <Link to={'revenue'}>Revenue</Link>,
      hasAccess: hasAccess([Permission.createAdmin]),
    },
  ]

  return (
    <Layout>
      <MainHeader subItems={subItems.filter((item) => item.hasAccess)} />
      <Layout style={{ minHeight: '100vh', marginTop: 128 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
        <LayoutFooter />
      </Layout>
    </Layout>
  )
}
